<template>
    <div class="shop_title">
        Акции
    </div>
    <div class="shop_sale-slider">
        <div class="shop_sale-slider_control">
            <div class="shop_sale-slider_control-btn shop_sale-slider_control-btn-prev" @click="sliderControl('prev')">
                <img src="../../assets/img/arrow.svg">
            </div>
            <div class="shop_sale-slider_control-btn shop_sale-slider_control-btn-next" @click="sliderControl('next')">
                <img src="../../assets/img/arrow.svg">
            </div>
        </div>
        <swiper
            :modules="modules"
            :speed="500"
            :breakpoints = "{
                0: {
                    slidesPerView: 'auto',
                    spaceBetween: 15
                },
                // when window width is >= 480px
                900: {
                    slidesPerView: 'auto',
                    spaceBetween: 30
                },
                // when window width is >= 640px
                1200: {
                    slidesPerView: 'auto',
                    spaceBetween: 20
                }
            }"
        >
            <swiper-slide v-for="(item, index) in items" :key="index">
                <shop-sale-item :item="item"/>
            </swiper-slide>
        </swiper>

    </div>
</template>

<script>
    import { Navigation, A11y } from 'swiper';
    import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
    import "swiper/swiper-bundle.css";

    import ShopSaleItem from "./ShopSaleItem";

    export default {
        name: "ShopSaleSlider",
        components: {ShopSaleItem, Swiper, SwiperSlide},
        props: {
        },
        computed: {
            items: function () {
                return this.$store.getters.shopSales
            }
        },
        created() {
        },
        methods: {
            sliderControl(direction){
                const swiper = document.querySelector('.swiper').swiper;
                if (direction === 'next'){
                    swiper.slideNext();
                }else{
                    swiper.slidePrev();
                }
            },
        },
        setup() {
            return {
                modules: [Navigation, A11y],
            };
        },
    }
</script>